import * as React from 'react';

import { Icon, TIconType } from '../../components/Icon';

interface IUndergroundIconProps {
  regionId: number;
}

export function UndergroundIcon(props: IUndergroundIconProps) {
  const { regionId } = props;
  let metroType: TIconType;

  switch (regionId) {
    case -1:
    case 1:
    case 4593:
      metroType = 'mosmetro';
      break;
    case -2:
    case 2:
    case 4588:
      metroType = 'spbmetro';
      break;
    default:
      metroType = 'metro';
      break;
  }

  return (
    <Icon type={metroType} size={16} color="inherit" />
  );
}
